import { $ } from './constants';

const moveIntoView = (elementId, duration = 1000) => {
    $('html, body').animate({
        scrollTop: $(`#${elementId}`).offset().top
    }, duration);
};

export default moveIntoView;
